import {
  SET_EXTENDABLE_TYPE,
  SET_EXTENDABLE_ID,
  RESET_STATE,
  SET_EXTENDABLE_BACK_TO,
  SET_EXTENDABLE_SAVE_DISABLED
} from "../actions/types";

const initialState = {
  type: null,
  id: null,
  content: null,
  saveDisabled: true,
  backTo: null,
  props: {}
};

export function extendableReducer(state = initialState, action) {
  switch (action.type) {
    case SET_EXTENDABLE_TYPE:
      return {
        ...state,
        type: action.payload.val,
        saveDisabled: true,
        props: action.payload.props || {}
      };
    case SET_EXTENDABLE_ID:
      return {
        ...state,
        id: action.val,
        saveDisabled: true
      };
    case SET_EXTENDABLE_BACK_TO:
      return {
        ...state,
        backTo: action.val,
        saveDisabled: true
      };
    case SET_EXTENDABLE_SAVE_DISABLED:
      return {
        ...state,
        saveDisabled: action.bool
      };
    case RESET_STATE:
      return { ...initialState };
    default:
      return state;
  }
}
